export const ADD_AUTOPLAY_VIDEO = 'ADD_AUTOPLAY_VIDEO';
export const SET_AUTOPLAY_VIDEO_IN_VIEW = 'SET_AUTOPLAY_VIDEO_IN_VIEW';

export default {
  ADD_AUTOPLAY_VIDEO,
  SET_AUTOPLAY_VIDEO_IN_VIEW
};
